import {Permissions} from 'auth/PermissionConstants';
import TemplateActions from 'notebook/entry-templates/TemplateActions';
import {OngoingTaskResponse} from 'util/TaskRunner';

import {Review} from './ReviewConstants';

/**
 * Merges post-review-action server review and permissions into TemplateStore so the editor lock
 * path (writable → allowEdits → locked) and review banner update immediately after send-for-review.
 */
export default function postTemplateReviewActionServerUpdate(
  templateId: string,
  review: Review,
  permissions: Permissions,
  _snapshotTask: OngoingTaskResponse | null
): void {
  TemplateActions.postServerUpdate(templateId, {review, permissions});
}
